module.exports = __webpack_public_path__ + "static/media/marek_wolfryd_14.df7ebe6b.jpg";